import { render, staticRenderFns } from "./registeCerticate.vue?vue&type=template&id=5471e850&scoped=true"
import script from "./registeCerticate.vue?vue&type=script&lang=js"
export * from "./registeCerticate.vue?vue&type=script&lang=js"
import style0 from "./registeCerticate.vue?vue&type=style&index=0&id=5471e850&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5471e850",
  null
  
)

export default component.exports